import React, { Component } from 'react';
import { connect } from 'react-redux';
import __ from 'lodash';
import { cekCookies } from '../../../../actions';
import axios from 'axios';
import { CONFIG } from '../../../../config';
import Navbar from '../../navbar/Navbar';
import Sidebar from '../../sidebar/Sidebar';
import LoaderModal from '../../../modal/LoaderModal';
import accountManagement from '../../../../apis/accountManagement';

import Autocomplete from '@material-ui/lab/Autocomplete';
import { TextField, Typography, Grid } from '@material-ui/core';

class index extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            totalHarga: null,
            listPaketProgram: []
        }
    }

    async componentDidMount() {
        await this.props.cekCookies();
    }

    render() {
        const { isFetching, listPaketProgram, idPaketProgram, jumlahSiswa, totalHarga } = this.state;
        return (
            <div className="wrapper">
                <LoaderModal isFetching={isFetching} />
                <Sidebar account={this.props.account} />
                <div id="content" style={{ paddingBottom: '50px' }}>
                    <Navbar />
                    <Grid
                        spacing={3}
                        container
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="baseline"
                    >
                        <Grid item xs={12}>
                            <Grid
                                container
                                direction="row"
                                justifyContent="space-between"
                                alignItems="baseline"
                            >
                                <Grid item xs={12} md={12} xl={12}>
                                    <Typography variant="body1" color="textPrimary" style={{ float: 'right' }}>Rp. {totalHarga > 0 ? totalHarga : '0'}</Typography>
                                </Grid>
                                <Grid item xs={12} md={12} xl={12}>
                                    <Typography variant="h5" color="textPrimary">Pembelian Paket Event</Typography>
                                </Grid>

                            </Grid>
                        </Grid>

                        <Grid item xs={12} md={4} xl={4}>
                            <Autocomplete
                                id="idPaketProgram"
                                size="small"
                                disableClearable
                                options={listPaketProgram}
                                getOptionLabel={(option) => option.namaPaketProgram}
                                disableClearable
                                renderInput={(params) =>
                                    <TextField {
                                        ...params}
                                        label="Pilih Paket Program"
                                        variant="outlined" />
                                }
                            />
                        </Grid>

                        <Grid item xs={12} md={2} xl={2}>
                            <TextField
                                id="jumlahSiswa"
                                label="Jumlah Pembelian"
                                size="small"
                                variant="outlined"
                                value={jumlahSiswa}
                                onChange={this.handleOnChange}

                            />
                        </Grid>
                    </Grid>
                </div>
            </div>
        );
    }

    handleOnChange = async (e) => {
        const { id, value } = e.target;

        if(id === "jumlahSiswa"){
            this.setState({ 
                [id]: value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1'),
                totalHarga: 2500 * value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')
            });
        }else{
            this.setState({ 
                [id]: value
            });
        }
        
    }
}

const mapStateToProps = (state) => {
    return {
        account: state.account
    };
}
export default connect(mapStateToProps, { cekCookies })(index)